import script from "./TheBaseNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheBaseNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./TheBaseNavigation.vue?vue&type=style&index=0&id=1507255f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1507255f"]])

export default __exports__